import { render, staticRenderFns } from "./UseSelect.vue?vue&type=template&id=2009eac2&lang=pug"
import script from "./UseSelect.vue?vue&type=script&lang=js"
export * from "./UseSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports